(function () {
  if (window.__jklYotpoReviewsExpandInit) {
    return;
  }

  window.__jklYotpoReviewsExpandInit = true;

  const COLLAPSED_READ_MORE_SELECTOR =
    '.yotpo-reviews-main-widget .yotpo-read-more[data-position="closed"], .yotpo-standalone-section .yotpo-read-more[data-position="closed"]';

  let debounceTimer;

  const expandCollapsedReviews = () => {
    document.querySelectorAll(COLLAPSED_READ_MORE_SELECTOR).forEach((button) => {
      button.click();
    });
  };

  const scheduleExpand = () => {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(expandCollapsedReviews, 50);
  };

  const init = () => {
    expandCollapsedReviews();

    const observer = new MutationObserver(scheduleExpand);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
